// client/src/components/common/PagePanel.jsx
// Панель внутри PageShell: рамка + фон + скругление.
// Используется для Header / Actions / Content и любых блоков.
import React from 'react';
import { Box } from '@mui/material';

export default function PagePanel({ children, sx = {} }) {
  return (
    <Box
      sx={{
        borderRadius: 1,
        border: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        minHeight: 0,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
